// @flow

import React, { Component } from 'react';
import type { Element } from 'react';
import styled from 'styled-components';
import raf from 'raf';
import theme from '../themes';
import iOSRightIcon from '../icons/ios-right-icon.svg';

export const FULL_VH = (document.documentElement: any).clientHeight;

export const NavBackLabel = styled.span`
  margin-left: 15px;
`;

export const BackArrow = styled.div`
  ${theme.BackArrow};
`;

export const Back = styled.div`
  display: flex;
  position: relative;
  ${theme.Back}
`;

export const Navbar = styled.div`
  display: flex;
  ${theme.Navbar}
`;

export const SmartViewNavbar = styled.div`
  display: flex;
  ${theme.SmartViewNavbar}
`;

export const SmartButton = styled.button.attrs({
  className: 'smart-button'
})`
  padding: 0;
  width: 100%;
  ${theme.SmartButton}
`;

export const ValueWrapper = styled.div`
  ${theme.ValueWrapper}
`;

export const Value = styled.div`
  color: #777777;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  ${theme.Value};
`;

export const Arrow = styled.div.attrs({
  dangerouslySetInnerHTML: {__html: iOSRightIcon}
})`
  display: inline-block;
  height: 13px;
  margin-left: 11px;
  vertical-align: middle;
  > svg {
    fill: #c8c7cc;
    height: 13px;
  }
`;

export const NavItem = styled.div`
  display: inline-block;
  ${(props) => props.left && theme.NavBack};
  ${(props) => props.center && theme.NavCenter};
  ${(props) => props.right && theme.NavRight};
`;

export const SectionContainer = styled.div`
  ${theme.SectionContainer}
`;

export const SectionBody = styled.div.attrs({
  className: 'section-body'
})`
  ${theme.SectionBody};
`;

export const Screen = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: ${theme.backgroundColor};
  z-index: 5000;
  ${theme.Screen}
`;

type PageProps = {
  className?: string,
  onScroll: (*) => void,
  children: Element<*>
};

export const Page = styled(
  class extends Component<PageProps, void> {
    constructor(props: Object) {
      super(props);
      (this: any).ref = null;
    }

    onRef = (ref: *) => {
      (this: any).ref = ref;
      if (this.ref) {
        (this: any).ref.addEventListener('scroll', this.handleScroll);
        (this: any).ref.addEventListener('touchmove', this.handleScroll);
      }
    };

    handleScroll = () => {
      raf(() => {
        this.props.onScroll({
          scrolling: (this: any).ref.scrollTop !== 0,
          top: (this: any).ref.scrollTop
        });
      });
    };

    componentWillUmmount() {
      (this: any).ref.removeEventListener('scroll', this.handleScroll);
      (this: any).ref.removeEventListener('touchmove', this.handleScroll);
    }

    render() {
      const { className, children } = this.props;
      return (
        <div ref={this.onRef} className={className}>
          {children}
        </div>
      );
    }
  }
)`
  height: ${({ navbarHeight }) => FULL_VH - navbarHeight}px;
  margin-top: ${({ navbarHeight }) => navbarHeight}px;
  overflow-y: auto;
  // Force GPU Accel
  transform: translate3d(0, 0, 0);
  width: 100%;
  ${theme.Page}
  > div {
    padding-bottom: 60px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Common.js